const API_URL = process.env.REACT_APP_API_URL
import BaseApi from "./baseApi"
import axios from "axios"

class AuthApi extends BaseApi {
  constructor() {
    super()
    this.baseUrl = "/users" // Adjust the base URL according to your API endpoints
  }

  getAdminDashboardData(token) {
    const endPoint = `${API_URL}/dashboard/get-admin-dashboard-data`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getAllInvoices(data, token) {
    const endPoint = `${API_URL}/dashboard/get-all-invoices`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getOTPRequest(data) {
    console.log("AuthApi getOTPRequest called with:", data)

    const endPoint = `${this.baseUrl}/send-otp-on-mobile`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }
    return this.fetchData(axiosRq)
  }

  getOTPPVSRequest(data) {
    console.log("AuthApi getOTPPVSRequest called with:", data)

    const endPoint = `${this.baseUrl}/search-with-pvs-and-send-otp`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }
    return this.fetchData(axiosRq)
  }

  login(data) {
    const endPoint = `${this.baseUrl}/login-user`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }
    return this.fetchData(axiosRq)
  }

  signup(data) {
    const endPoint = `${this.baseUrl}/sign-up-user`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    }
    return this.fetchData(axiosRq)
  }

  getUserDetails(token) {
    const endPoint = `${this.baseUrl}/get-user-details`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  logout() {
    const endPoint = `${this.baseUrl}/logout`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  getCurrentUser() {
    const endPoint = `${this.baseUrl}/me`
    const axiosRq = {
      url: endPoint,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  updateProfile(userData, token) {
    const endPoint = `${this.baseUrl}/update-user-profile`
    const axiosRq = {
      url: endPoint,
      data: userData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  forgotPassword(email) {
    const endPoint = `${API_URL}${this.baseUrl}/forgot-password`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: { email },
      headers: {
        "Content-Type": "application/json",
      },
    }
    return this.fetchData(axiosRq)
  }

  socialLogin(provider, token) {
    const endPoint = `${API_URL}${this.baseUrl}/social/${provider}`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: { token },
      headers: {
        "Content-Type": "application/json",
      },
    }
    return this.fetchData(axiosRq)
  }
}

const authApi = new AuthApi()

export default authApi
